export default __webpack_public_path__ + "img/membership-banner-img-b8accb10997700d9d522ae380c7e11c0.png";